import React from 'react';
import PropTypes from 'prop-types';
import { Icon, IconText } from '@reservamos/elements';
import i18n from 'i18next';
import useWhitelabelTheme from '../../hooks/whitelabel/useWhitelabelTheme';
import amenities from '../../images/indexAmenities';

const Amenity = ({ isIcon, type, isVertical, iconSize }) => {
  const { amenities: customAmenities } = useWhitelabelTheme();
  const amenityType = customAmenities[type] || amenities[type] || amenities.amenity;

  if (isIcon) return <Icon type={amenityType} size={iconSize} />;

  const translationKey = `common:constant.amenity_${type}`;
  const hasTranslation = i18n.exists(translationKey);

  return (
    <IconText
      isVertical={isVertical}
      mobileInline
      iconType={amenityType}
      fontSize="S"
      label={hasTranslation ? i18n.t(translationKey) : type}
      iconSize={iconSize}
    />
  );
};

Amenity.propTypes = {
  /** Amenity type */
  type: PropTypes.string.isRequired,
  iconSize: PropTypes.string,
  isIcon: PropTypes.bool,
  isVertical: PropTypes.bool,
};

Amenity.defaultProps = {
  isIcon: false,
  isVertical: false,
  iconSize: 'M',
};

export default Amenity;
